import UploadButton from "./uploadButton.js";
export default {
  name: "MoreButton",
  functional: true,
  components: {
    UploadButton
  },
  props: {
    owner: {
      type: Object,
      default() {
        return {};
      }
    },
    placement: {
      type: String,
      default: "bottom"
    }
  },
  render(h, _vm) {
    const { props, listeners } = _vm;
    const { owner, placement } = props;
    return (
      <el-popover
        class={["ds-button__more", owner.size]}
        popper-class="ds-morebutton-popover"
        width="auto"
        trigger="click"
        on={{
          show: owner.popoverShow,
          hide: owner.popoverClose
        }}
        ref="more-button-popover"
        placement={placement}
        nativeOn={listeners}
      >
        <div
          class="el-row"
          style={{
            width: owner.moreButtonsReal.length > owner.moreBtnColNum ? "240px" : "80px"
          }}
        >
          {renderButtons(h, _vm)}
        </div>
        {renderMoreButton(h, _vm)}
      </el-popover>
    );
  }
};

function renderButtons(h, _vm) {
  const { props } = _vm;
  const { owner } = props;
  // button.btnStyle="icon-text"
  return owner.moreButtonsReal.map((button, $index) => {
    return (
      <div
        class="el-col"
        style="text-align: center"
        key={`more_buttonsReal_${$index}`}
        class={["el-col-" + (owner.moreButtonsReal.length > owner.moreBtnColNum ? 8 : 24)]}
      >
        {button.isUpload && !button.isUploadImportTemplate ? (
          <UploadButton
            key={`is_upload_${$index}`}
            button={button}
            btn-style="icon-text"
            style="width: 80px; margin-bottom: 5px; margin-top: 5px"
            owner={owner}
          ></UploadButton>
        ) : (
          <DsfButton
            key={`_${$index}`}
            style="width: 80px; margin-bottom: 5px; margin-top: 5px"
            icon={owner.getIcon(button)}
            disabled={button.disabled}
            size={owner.size}
            type={button.type}
            title={button.title}
            btn-style="icon-text"
            loading={button.loading}
            on-click={($event) => {
              owner.clickHandler(button, $event);
            }}
          >
            {button.text}
          </DsfButton>
        )}
      </div>
    );
  });
}

function renderMoreButton(h, _vm) {
  let props = _vm.props;
  let vnode = null;
  if (props.owner.moreButtonsReal.length && props.owner.moreButtonStyle != "icon-text") {
    vnode = (
      <DsfButton
        slot="reference"
        title={props.owner.moreButtonText}
        btn-style={props.owner.moreButtonStyle}
        icon={props.owner.moreFold ? "shuangjiantouxia" : "xiangshangzhanhang"}
        size={props.owner.size}
        class={["plain", props.owner.moreButtonStyle]}
      >
        {props.owner.moreButtonText}
      </DsfButton>
    );
  } else if (props.owner.moreButtonsReal.length && props.owner.moreButtonStyle == "icon-text") {
    vnode = (
      <DsfButton
        slot="reference"
        title={props.owner.moreButtonText}
        btn-style={props.owner.moreButtonStyle}
        icon="gengduo1"
        size={props.owner.size}
        class={["plain", props.owner.moreButtonStyle]}
      >
        {props.owner.moreButtonText}
      </DsfButton>
    );
  }
  return vnode;
}
